export const ACTIVITY_STATUS_PADDING = 1
export const ACTIVITY_STATUS_SUCCESS = 2
export const ACTIVITY_STATUS_FAIL = 3
